import type { Transition, Variants } from "motion/react";

export const spring = {
  snappy: { type: "spring", stiffness: 500, damping: 35 } satisfies Transition,
  gentle: { type: "spring", stiffness: 260, damping: 30 } satisfies Transition,
};

export const fadeUp: Variants = {
  hidden: { opacity: 0, y: 12 },
  show: { opacity: 1, y: 0, transition: spring.gentle },
};

export const fadeOnly: Variants = {
  hidden: { opacity: 0 },
  show: { opacity: 1, transition: { duration: 0.2 } },
};

export const stagger = (step = 0.03): Variants => ({
  hidden: {},
  show: { transition: { staggerChildren: step } },
});

export const press = { scale: 0.97 };
